/**
 * Avatar colour palette — used when a user has no profile photo.
 *
 * Each entry is a (bg, text) pair:
 *  • bg   — light pastel background for the avatar circle
 *  • text — dark shade of the same hue for the initials
 *
 * Deliberately avoids white, near-black, and brown.
 * 12 distinct hues keeps collisions low for typical group sizes (≤ 10).
 */
export const AVATAR_PALETTE: { bg: string; text: string }[] = [
  { bg: '#DBEAFE', text: '#1E40AF' }, // Blue
  { bg: '#EDE9FE', text: '#5B21B6' }, // Violet
  { bg: '#FCE7F3', text: '#9D174D' }, // Pink
  { bg: '#FFE4E6', text: '#9F1239' }, // Rose
  { bg: '#FFEDD5', text: '#9A3412' }, // Orange
  { bg: '#FEF9C3', text: '#854D0E' }, // Yellow
  { bg: '#DCFCE7', text: '#166534' }, // Green
  { bg: '#CCFBF1', text: '#0F766E' }, // Teal
  { bg: '#CFFAFE', text: '#0E7490' }, // Cyan
  { bg: '#E0E7FF', text: '#3730A3' }, // Indigo
  { bg: '#F3E8FF', text: '#6B21A8' }, // Purple
  { bg: '#FAE8FF', text: '#86198F' }, // Fuchsia
];

/**
 * Deterministically maps a user ID to a palette entry.
 * The same user always gets the same colour; different users
 * distributed across the 12 slots by a simple char-code hash.
 */
export function getAvatarColor(userId: string): { bg: string; text: string } {
  const hash = userId
    .split('')
    .reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
}
